export default {
    initialMergeFields: {},
    initialMergeServiceFields: {},
    settings: {},
};
